//import React from 'react';
import hasData from './hasData';
import hasNotification from './hasNotification';
import hasStorage from './hasStorage';
import localize from './localize';
import {compose} from 'redux';
const isPage = (WrappedComponent) => {

	return (
		compose(hasNotification, hasData, hasStorage, localize)(WrappedComponent)
	);

}
export default isPage;


// const isContainer = ({data, Error, DefaultComponent}) => WrappedComponent => {
//   const IsContainer = props => <WrappedComponent {...props} />

//   return compose(
//     hasData(data),
//     hasLoader,
//     hasError(Error),
//     hasDefault(DefaultComponent)
//   )(IsContainer)
// }

// export default isContainer


// WEBPACK FOOTER //
// ./src/hoc/isPage.js